<template>
  <div class="app-package-download-page">
    <div class="page-shell">
      <div class="hero-section">
        <div class="hero-top">
          <div class="hero-brand">
            <div class="hero-logo">
              <img :src="logoImage" alt="Logo" class="hero-logo__image">
            </div>
            <div class="hero-badge">公开下载页</div>
          </div>
          <div class="hero-actions">
            <el-button
              plain
              class="hero-action-btn"
              @click="openExternalLink(instructionUrl)"
            >
              操作说明
            </el-button>
            <el-button
              plain
              class="hero-action-btn"
              @click="openExternalLink(feedbackUrl)"
            >
              问题反馈
            </el-button>
          </div>
        </div>
        <div class="hero-title">智能检测客户端安装包下载</div>
        <div class="hero-meta">
        </div>
      </div>

      <div class="platform-grid">
        <div class="platform-card platform-card--android">
          <div class="platform-card__head">
            <div class="platform-card__title-wrap">
              <span class="platform-card__icon platform-card__icon--android">
                <svg viewBox="0 0 64 64" aria-hidden="true" class="platform-card__svg">
                  <path d="M22 18 17 10.5" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" />
                  <path d="M42 18 47 10.5" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" />
                  <path d="M20 20c0-7 5.4-12 12-12s12 5 12 12v4H20v-4Z" fill="currentColor" />
                  <rect x="16" y="22" width="32" height="24" rx="7" fill="currentColor" />
                  <rect x="8" y="23" width="6.5" height="18" rx="3.2" fill="currentColor" />
                  <rect x="49.5" y="23" width="6.5" height="18" rx="3.2" fill="currentColor" />
                  <rect x="23" y="44" width="6.5" height="14" rx="3.2" fill="currentColor" />
                  <rect x="34.5" y="44" width="6.5" height="14" rx="3.2" fill="currentColor" />
                  <circle cx="26" cy="19" r="2.3" fill="#ffffff" />
                  <circle cx="38" cy="19" r="2.3" fill="#ffffff" />
                </svg>
              </span>
              <div class="platform-card__title">安卓版本</div>
            </div>
            <span class="platform-card__tag platform-card__tag--active">已接通</span>
          </div>
          <div class="platform-card__body">
            <div class="platform-info-row">
              <span class="platform-info-label">最新版本</span>
              <span class="platform-info-value">{{ androidVersionText }}</span>
            </div>
            <div class="android-qrcode">
              <div class="android-qrcode__box">
                <img v-if="androidQrCodeUrl" :src="androidQrCodeUrl" alt="安卓版本下载二维码" class="android-qrcode__image">
                <div v-else class="android-qrcode__placeholder">二维码生成中</div>
              </div>
              <div class="android-qrcode__text">微信或浏览器扫码下载</div>
            </div>
          </div>
          <el-button
            type="success"
            size="large"
            class="platform-download-btn"
            :loading="androidLoading"
            @click="handleDownload('安卓')"
          >
            <span class="btn-text-desktop">安卓版本下载</span>
            <span class="btn-text-mobile">下载</span>
          </el-button>
        </div>

        <div class="platform-card platform-card--harmony">
          <div class="platform-card__head">
            <div class="platform-card__title-wrap">
              <span class="platform-card__icon platform-card__icon--harmony">
                <svg viewBox="0 0 210 48" aria-hidden="true" class="platform-card__svg platform-card__svg--harmony">
                  <text x="0" y="33" font-size="30" font-weight="700" fill="currentColor" font-family="Arial, Helvetica, sans-serif">Harmony</text>
                  <text x="129" y="33" font-size="30" font-weight="700" fill="currentColor" font-family="Arial, Helvetica, sans-serif">OS</text>
                  <rect x="128" y="37" width="28" height="4" rx="2" fill="#2f6df6" />
                </svg>
              </span>
              <div class="platform-card__title">鸿蒙版本</div>
            </div>
            <span class="platform-card__tag platform-card__tag--active">已接入</span>
          </div>
          <div class="platform-card__body">
            <div class="platform-info-row">
              <span class="platform-info-label">当前状态</span>
              <span class="platform-info-value">可跳转至鸿蒙企业应用市场安装</span>
            </div>
            <div class="android-qrcode">
              <div class="android-qrcode__box">
                <img v-if="harmonyQrCodeUrl" :src="harmonyQrCodeUrl" alt="鸿蒙版本下载二维码" class="android-qrcode__image">
                <div v-else class="android-qrcode__placeholder">二维码生成中</div>
              </div>
              <div class="android-qrcode__text">请使用鸿蒙设备扫码后打开本下载页</div>
            </div>
          </div>
          <el-button
            type="warning"
            size="large"
            class="platform-download-btn"
            @click="handleHarmonyDownload"
          >
            <span class="btn-text-desktop">鸿蒙版本下载</span>
            <span class="btn-text-mobile">下载</span>
          </el-button>
        </div>

        <div class="platform-card platform-card--windows">
          <div class="platform-card__head">
            <div class="platform-card__title-wrap">
              <span class="platform-card__icon platform-card__icon--windows">
                <svg viewBox="0 0 64 64" aria-hidden="true" class="platform-card__svg">
                  <path d="M8 12 29 9v22H8V12Z" fill="currentColor" />
                  <path d="M33 8.5 56 5v25H33V8.5Z" fill="currentColor" />
                  <path d="M8 35h21v20L8 52V35Z" fill="currentColor" />
                  <path d="M33 35h23V59l-23-3V35Z" fill="currentColor" />
                </svg>
              </span>
              <div class="platform-card__title">Windows版本</div>
            </div>
            <span class="platform-card__tag platform-card__tag--active">已接通</span>
          </div>
          <div class="platform-card__body">
            <div class="platform-info-row">
              <span class="platform-info-label">最新版本</span>
              <span class="platform-info-value">{{ windowsVersionText }}</span>
            </div>
          </div>
          <el-button
            plain
            type="primary"
            class="platform-runtime-btn"
            @click="handleWindowsRuntimeDownload"
          >
            <span class="runtime-text-desktop">下载运行环境</span>
            <span class="runtime-text-mobile">运行环境</span>
          </el-button>
          <el-button
            type="primary"
            size="large"
            class="platform-download-btn"
            :loading="windowsLoading"
            @click="handleDownload('windows')"
          >
            <span class="btn-text-desktop">Windows版本下载</span>
            <span class="btn-text-mobile">下载</span>
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import { ElMessage } from 'element-plus'
import QRCode from 'qrcode'
import AppVersionAdminApi from '@/network/apis/AppVersionAdmin'
import logoImage from '@/assets/img/Logo.png'

const androidLoading = ref(false)
const windowsLoading = ref(false)
const latestAndroidVersion = ref('')
const latestWindowsVersion = ref('')
const androidQrCodeUrl = ref('')
const harmonyQrCodeUrl = ref('')
const androidDownloadUrl = ref('')
const windowsRuntimeFileName = 'windowsdesktop-runtime-8.0.25-win-x64.exe'
const instructionUrl = 'https://cabrjyzt.feishu.cn/wiki/FVWHw2p5IiO2Jkk60cAc8lkfnub'
const feedbackUrl = 'https://www.feishu.cn/invitation/page/add_contact/?token=f11rdaeb-4cb8-43f0-a202-e27bce06f55d'
const HARMONY_MANIFEST_URL = 'https://zjys.cabr-betc.com/api/HarmonyApp/ManifestDownload/manifest.json5'
const HARMONY_STORE_URL = `store://enterprise/manifest?url=${encodeURIComponent(HARMONY_MANIFEST_URL)}`
const HARMONY_QR_PAGE_URL = 'https://zjys.cabr-betc.com/app-package-download'

const androidVersionText = computed(() => latestAndroidVersion.value || '正在获取')
const windowsVersionText = computed(() => latestWindowsVersion.value || '正在获取')

const getAbsoluteDownloadUrl = (fileName: string) => {
  const downloadUrl = AppVersionAdminApi.getPublicDownloadUrl(fileName)
  return new URL(downloadUrl, window.location.origin).toString()
}

const getQrDownloadUrl = (fileName: string) => {
  const publicBaseUrl = window.PROJECT_CONFIG?.PUBLIC_DOWNLOAD_BASE_URL
  const downloadUrl = AppVersionAdminApi.getPublicDownloadUrl(fileName, publicBaseUrl)
  return new URL(downloadUrl, window.location.origin).toString()
}

const triggerDownload = (fileName: string) => {
  window.location.assign(getAbsoluteDownloadUrl(fileName))
}

const openExternalLink = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer')
}

const generateAndroidQrCode = async (fileName: string) => {
  if (!fileName) {
    androidQrCodeUrl.value = ''
    return
  }

  try {
    androidDownloadUrl.value = getQrDownloadUrl(fileName)
    androidQrCodeUrl.value = await QRCode.toDataURL(androidDownloadUrl.value, {
      width: 180,
      margin: 1,
      errorCorrectionLevel: 'M',
    })
  } catch (error) {
    console.error('生成安卓下载二维码失败:', error)
    androidQrCodeUrl.value = ''
  }
}

const generateHarmonyQrCode = async () => {
  try {
    harmonyQrCodeUrl.value = await QRCode.toDataURL(HARMONY_QR_PAGE_URL, {
      width: 180,
      margin: 1,
      errorCorrectionLevel: 'M',
    })
  } catch (error) {
    console.error('生成鸿蒙下载二维码失败:', error)
    harmonyQrCodeUrl.value = ''
  }
}

const loadLatestAndroidVersion = async () => {
  try {
    const res = await AppVersionAdminApi.checkLatestVersionPublic('安卓')
    latestAndroidVersion.value = res?.response?.版本号 || ''
    const fileName = res?.response?.文件名
    await generateAndroidQrCode(fileName || '')
  } catch (error) {
    console.error('获取安卓最新版本失败:', error)
    latestAndroidVersion.value = ''
    androidDownloadUrl.value = ''
    androidQrCodeUrl.value = ''
  }
}

const loadLatestWindowsVersion = async () => {
  try {
    const res = await AppVersionAdminApi.checkLatestVersionPublic('windows')
    latestWindowsVersion.value = res?.response?.版本号 || ''
  } catch (error) {
    console.error('获取Windows最新版本失败:', error)
    latestWindowsVersion.value = ''
  }
}

const handleDownload = async (type: string) => {
  if (type !== '安卓' && type !== 'windows') {
    ElMessage.warning(`${type}版本暂未开放下载`)
    return
  }

  const isWindows = type === 'windows'
  const loadingRef = isWindows ? windowsLoading : androidLoading
  const versionRef = isWindows ? latestWindowsVersion : latestAndroidVersion
  const requestType = isWindows ? 'windows' : '安卓'
  const displayType = isWindows ? 'Windows' : '安卓'

  loadingRef.value = true
  try {
    const res = await AppVersionAdminApi.checkLatestVersionPublic(requestType)
    const fileName = res?.response?.文件名
    const version = res?.response?.版本号

    if (!fileName) {
      ElMessage.warning('未获取到最新安装包文件名')
      return
    }

    versionRef.value = version || ''
    if (!isWindows) {
      await generateAndroidQrCode(fileName)
    }
    triggerDownload(fileName)
  } catch (error) {
    console.error(`获取${displayType}安装包失败:`, error)
    ElMessage.error(`${displayType}安装包下载失败，请稍后重试`)
  } finally {
    loadingRef.value = false
  }
}

const handleWindowsRuntimeDownload = () => {
  triggerDownload(windowsRuntimeFileName)
}

const handleHarmonyDownload = () => {
  window.location.href = HARMONY_STORE_URL
}

onMounted(() => {
  loadLatestAndroidVersion()
  loadLatestWindowsVersion()
  generateHarmonyQrCode()
})
</script>

<style lang="less" scoped>
.app-package-download-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  box-sizing: border-box;
  background:
    radial-gradient(circle at top left, rgba(64, 158, 255, 0.18), transparent 28%),
    radial-gradient(circle at top right, rgba(103, 194, 58, 0.14), transparent 24%),
    linear-gradient(180deg, #f4f7fb 0%, #eef3ff 100%);
}

.page-shell {
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
}

.hero-section {
  position: relative;
  overflow: hidden;
  padding: 44px 48px;
  border-radius: 28px;
  background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 60%, #3b82f6 100%);
  box-shadow: 0 24px 60px rgba(37, 99, 235, 0.22);
  color: #fff;
}

.hero-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}

.hero-brand {
  display: flex;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
  min-width: 0;
}

.hero-logo {
  width: clamp(120px, 16vw, 190px);
  max-width: 42%;
  flex-shrink: 0;
}

.hero-logo__image {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 12px;
}

.hero-action-btn.el-button {
  height: 40px;
  padding: 0 18px;
  border-radius: 999px;
  border-color: rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
  backdrop-filter: blur(10px);
}

.hero-action-btn.el-button:hover,
.hero-action-btn.el-button:focus {
  border-color: rgba(255, 255, 255, 0.46);
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.2);
  font-size: 13px;
}

.hero-title {
  margin-top: 20px;
  font-size: 40px;
  line-height: 1.2;
  font-weight: 700;
}

.hero-subtitle {
  max-width: 760px;
  margin-top: 14px;
  font-size: 15px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.88);
}

.hero-meta {
  margin-top: 26px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.meta-item {
  min-width: 220px;
  padding: 16px 18px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(8px);
}

.meta-label {
  display: block;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

.meta-value {
  display: block;
  margin-top: 8px;
  font-size: 17px;
  font-weight: 600;
  color: #fff;
  word-break: break-all;
}

.platform-grid {
  margin-top: 28px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.platform-card {
  display: flex;
  flex-direction: column;
  min-height: 320px;
  padding: 24px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.72);
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(14px);
  justify-content: center;
}

.platform-card--android {
  box-shadow: 0 18px 42px rgba(103, 194, 58, 0.14);
}

.platform-card--harmony {
  box-shadow: 0 18px 42px rgba(230, 162, 60, 0.14);
}

.platform-card--windows {
  box-shadow: 0 18px 42px rgba(64, 158, 255, 0.14);
}

.platform-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  min-height: 52px;
}

.platform-card__title-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.platform-card__icon {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
}

.platform-card__svg {
  width: 24px;
  height: 24px;
  display: block;
}

.platform-card__svg--harmony {
  width: 104px;
  height: 24px;
}

.platform-card__icon--android {
  background: rgba(103, 194, 58, 0.14);
  color: #a4c639;
}

.platform-card__icon--harmony {
  width: auto;
  min-width: 112px;
  padding: 0 10px;
  background: rgba(255, 255, 255, 0.82);
  color: #111111;
}

.platform-card__icon--windows {
  background: rgba(64, 158, 255, 0.14);
  color: #2f7dde;
}

.platform-card__title {
  font-size: clamp(16px, 1.6vw, 24px);
  font-weight: 700;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.platform-card__desc {
  margin-top: 8px;
  font-size: 14px;
  line-height: 1.7;
  color: #6b7280;
}

.platform-card__tag {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  height: 30px;
  padding: 0 12px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 12px;
  font-weight: 600;
}

.platform-card__tag--active {
  background: rgba(103, 194, 58, 0.14);
  color: #529b2e;
}

.platform-card__actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  flex-shrink: 0;
}

.platform-runtime-btn.el-button {
  width: 100%;
  min-height: 38px;
  height: 38px;
  margin: 16px 0 0;
  padding: 0 14px;
  border-radius: 10px;
  border-color: #bfdbfe;
  background: rgba(239, 246, 255, 0.96);
  color: #2563eb;
  font-size: 13px;
  font-weight: 600;
  align-self: stretch;
}

.platform-runtime-btn.el-button:hover,
.platform-runtime-btn.el-button:focus {
  border-color: #93c5fd;
  background: #dbeafe;
  color: #1d4ed8;
}

.platform-card--windows .platform-download-btn {
  margin-top: 10px;
}

.platform-runtime-btn.el-button + .platform-download-btn.el-button {
  margin-left: 0;
}

/* 中等宽度（例如在管理系统内部，内容区被侧边栏压窄）：改为单列堆叠，避免 3 列挤压 */
@media (min-width: 769px) and (max-width: 1180px) {
  .platform-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .platform-card {
    min-height: auto;
    padding: 20px;
  }

  .platform-card__title {
    font-size: 20px;
  }
}

.runtime-text-mobile {
  display: none;
}

.platform-card__body {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  flex: 1;
  justify-content: center;
}

.platform-info-row {
  padding: 14px 16px;
  border-radius: 16px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
}

.platform-info-label {
  display: block;
  font-size: 12px;
  color: #94a3b8;
}

.platform-info-value {
  display: block;
  margin-top: 6px;
  font-size: 15px;
  line-height: 1.6;
  color: #334155;
  font-weight: 600;
}

.android-qrcode {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.android-qrcode__box {
  width: 132px;
  height: 132px;
  padding: 8px;
  border-radius: 14px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
  box-sizing: border-box;
}

.android-qrcode__image {
  display: block;
  width: 100%;
  height: 100%;
}

.android-qrcode__placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 12px;
  text-align: center;
  line-height: 1.4;
  background: #f8fafc;
  border-radius: 8px;
}

.android-qrcode__text {
  color: #64748b;
  font-size: 12px;
  line-height: 1.4;
}

.platform-download-btn {
  width: 100%;
  height: 52px;
  margin-top: 24px;
  font-size: 16px;
  border-radius: 14px;
  align-self: center;
}

.btn-text-mobile {
  display: none;
}

@media (max-width: 768px) {
  .app-package-download-page {
    padding: 14px;
  }

  .hero-section {
    padding: 24px 18px;
    border-radius: 22px;
  }

  .hero-top {
    flex-direction: column;
    align-items: flex-start;
    gap: 14px;
  }

  .hero-brand {
    width: 100%;
    justify-content: space-between;
    gap: 12px;
  }

  .hero-logo {
    width: clamp(92px, 28vw, 128px);
    max-width: 48%;
  }

  .hero-actions {
    width: 100%;
    justify-content: flex-start;
    gap: 8px;
  }

  .hero-action-btn.el-button {
    height: 34px;
    padding: 0 12px;
    font-size: 12px;
  }

  .hero-title {
    font-size: 26px;
    line-height: 1.3;
  }

  .meta-item {
    width: 100%;
  }

  .platform-grid {
    margin-top: 18px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
  }

  .platform-card {
    min-height: 0;
    min-height: 390px;
    aspect-ratio: auto;
    padding: 12px 10px 10px;
    border-radius: 16px;
    justify-content: space-between;
  }

  .platform-card--android,
  .platform-card--harmony,
  .platform-card--windows {
    min-height: 390px;
  }

  .platform-card__head {
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    min-height: 0;
  }

  .platform-card__title-wrap {
    width: 100%;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    gap: 8px;
  }

  .platform-card__actions {
    width: 100%;
    align-items: center;
    gap: 4px;
  }

  .platform-card__icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    font-size: 20px;
  }

  .platform-card__svg {
    width: 22px;
    height: 22px;
  }

  .platform-card__svg--harmony {
    width: 70px;
    height: 18px;
  }

  .platform-card__icon--harmony {
    min-width: 78px;
    height: 48px;
    padding: 0 6px;
  }

  .platform-card__title {
    font-size: 14px;
    line-height: 1.25;
  }

  .platform-card__body {
    margin-top: 6px;
    gap: 0;
    flex: 1;
    justify-content: center;
    align-items: center;
  }

  .platform-info-row {
    padding: 0;
    border: none;
    background: transparent;
  }

  .platform-info-label {
    display: none;
  }

  .platform-info-value {
    margin-top: 0;
    font-size: 12px;
    line-height: 1.4;
    text-align: center;
    color: #64748b;
  }

  .android-qrcode {
    gap: 4px;
    margin-top: 4px;
  }

  .android-qrcode__box {
    width: clamp(72px, 18vw, 100px);
    height: clamp(72px, 18vw, 100px);
    padding: 4px;
    border-radius: 9px;
  }

  .android-qrcode__text {
    font-size: 10px;
    max-width: 260px;
    text-align: center;
  }

  .platform-download-btn {
    height: 42px;
    margin-top: 8px;
    padding: 0 8px;
    font-size: 13px;
    border-radius: 10px;
    width: 100%;
  }

  .platform-card__tag {
    display: none;
  }

  .platform-runtime-btn.el-button {
    height: 24px;
    min-height: 24px;
    margin: 4px 0 0;
    padding: 0 8px;
    font-size: 10px;
    line-height: 1.2;
    border-radius: 6px;
  }

  .platform-card--windows .platform-download-btn {
    margin-top: 4px;
  }

  .runtime-text-desktop {
    display: none;
  }

  .runtime-text-mobile {
    display: inline;
  }

  .btn-text-desktop {
    display: none;
  }

  .btn-text-mobile {
    display: inline;
  }
}

@media (max-width: 480px) {
  .app-package-download-page {
    padding: 12px;
  }

  .hero-section {
    padding: 20px 16px;
    border-radius: 18px;
  }

  .hero-badge {
    height: 28px;
    padding: 0 12px;
    font-size: 12px;
  }

  .hero-logo {
    width: clamp(84px, 30vw, 110px);
  }

  .hero-title {
    margin-top: 14px;
    font-size: 22px;
  }

  .hero-action-btn.el-button {
    height: 30px;
    padding: 0 10px;
    font-size: 11px;
  }

  .platform-grid {
    gap: 8px;
  }

  .platform-card {
    padding: 10px 8px 8px;
    min-height: 280px;
    border-radius: 14px;
  }

  .platform-card__icon {
    width: 42px;
    height: 42px;
  }

  .platform-card__icon--harmony {
    min-width: 68px;
    height: 42px;
    padding: 0 5px;
  }

  .platform-card__svg {
    width: 20px;
    height: 20px;
  }

  .platform-card__svg--harmony {
    width: 60px;
    height: 16px;
  }

  .platform-card__title {
    font-size: 12px;
  }

  .platform-info-value {
    font-size: 11px;
  }

  .platform-download-btn {
    height: 30px;
    font-size: 12px;
    border-radius: 8px;
  }
}
</style>
